(function () {
  var page = document.querySelector('#sca_fg_cart.cart-page');
  var form = page && page.querySelector('form.cart-form');
  if (!page || !form) return;

  var moneyFormat =
    page.getAttribute('data-money-format') ||
    (window.theme && theme.strings && theme.strings.moneyFormat) ||
    '{{amount}}';
  var updating = false;
  var urls = (function () {
    var el = document.querySelector('[data-cart-routes]');
    var data = {};
    try {
      data = JSON.parse((el && el.textContent) || '{}');
    } catch (e) {}
    function withJs(url, fallback) {
      url = url || fallback;
      return url.indexOf('.js') === -1 ? url + '.js' : url;
    }
    return {
      change: withJs(data.cartChangeUrl, '/cart/change'),
      cart: withJs(data.cartUrl, '/cart')
    };
  })();

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, moneyFormat);
    }
    return String(cents);
  }

  function markInputs() {
    page.querySelectorAll('.cart-page__qty-input').forEach(function (input) {
      input.classList.add('cart__product-qty');
    });
  }

  function setHeaderCount(count) {
    var n = Number(count) || 0;
    document.querySelectorAll('.cart-link__bubble').forEach(function (el) {
      el.classList.toggle('cart-link__bubble--visible', n > 0);
    });
  }

  function linePriceHtml(item) {
    if (item.original_line_price !== item.final_line_price) {
      return (
        '<s>' +
        formatMoney(item.original_line_price) +
        '</s> ' +
        formatMoney(item.final_line_price)
      );
    }
    return formatMoney(item.final_line_price);
  }

  function syncFromCart(cart) {
    if (!cart || !cart.items) return;
    if (cart.item_count === 0) {
      window.location.reload();
      return;
    }

    var byKey = {};
    cart.items.forEach(function (item, index) {
      byKey[item.key] = { item: item, line: index + 1 };
    });

    page.querySelectorAll('.cart-page__item[data-key]').forEach(function (row) {
      var found = byKey[row.getAttribute('data-key')];
      if (!found) {
        row.remove();
        return;
      }
      row.setAttribute('data-line', String(found.line));
      var input = row.querySelector('.cart-page__qty-input, .cart__product-qty');
      if (input) input.value = found.item.quantity;
      var priceEl = row.querySelector('.cart-page__price');
      if (priceEl) priceEl.innerHTML = linePriceHtml(found.item);
    });

    var subtotal = page.querySelector('[data-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    setHeaderCount(cart.item_count);
    syncCheckout(cart);
    if (window.Shopify) Shopify.cart = cart;
  }

  function syncCheckout(cart) {
    var button = form.querySelector('[name="checkout"]');
    if (!button) return;
    var items = (cart && cart.items) || [];
    var seen = false;
    var addonOnly = true;
    items.forEach(function (item) {
      if (!item || !(Number(item.quantity) > 0)) return;
      seen = true;
      var props = item.properties || {};
      if (String(props._cpt26_addon || '') !== '1') addonOnly = false;
    });
    var locked = seen && addonOnly;
    button.disabled = locked;
    button.setAttribute('aria-disabled', locked ? 'true' : 'false');
  }

  function changeLine(row, qty) {
    if (updating || !row) return;
    qty = parseInt(qty, 10);
    var key = row.getAttribute('data-key');
    var line = parseInt(row.getAttribute('data-line'), 10);
    if (isNaN(qty) || qty < 0 || (!key && !line)) return;

    updating = true;
    form.classList.add('is-updating');

    var payload = { quantity: qty };
    if (key) payload.id = key;
    else payload.line = line;

    fetch(urls.change, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || !data || !data.items) throw data;
          return data;
        });
      })
      .then(syncFromCart)
      .catch(function () {
        return fetch(urls.cart, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        })
          .then(function (res) {
            return res.json();
          })
          .then(syncFromCart);
      })
      .finally(function () {
        updating = false;
        form.classList.remove('is-updating');
      });
  }

  markInputs();

  form.addEventListener('submit', function (event) {
    var submitter = event.submitter;
    if (submitter && (submitter.name === 'checkout' || submitter.classList.contains('cart__checkout'))) {
      return;
    }
    event.preventDefault();
  });

  page.addEventListener(
    'click',
    function (event) {
      var trash = event.target.closest('.cart-remove-link');
      if (trash) {
        event.preventDefault();
        event.stopPropagation();
        var trashRow = trash.closest('.cart-page__item');
        if (trashRow) changeLine(trashRow, 0);
        return;
      }

      var adjust = event.target.closest('.cart-page__qty-btn');
      if (!adjust || adjust.disabled) return;
      event.preventDefault();
      event.stopPropagation();
      var row = adjust.closest('.cart-page__item');
      if (!row) return;
      var input = row.querySelector('.cart-page__qty-input, .cart__product-qty');
      if (!input) return;
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 1) qty = 1;
      if (adjust.getAttribute('data-qty-adjust') === 'plus') {
        qty += 1;
      } else {
        qty -= 1;
        if (qty < 1) qty = 1;
      }
      input.value = qty;
      changeLine(row, qty);
    },
    true
  );

  page.addEventListener('change', function (event) {
    if (!event.target.matches('.cart-page__qty-input, .cart__product-qty')) return;
    var row = event.target.closest('.cart-page__item');
    if (!row) return;
    var qty = parseInt(event.target.value, 10);
    if (isNaN(qty) || qty < 0) qty = 1;
    changeLine(row, qty);
  });

  var note = page.querySelector('#CartSpecialInstructions');
  if (note) {
    var noteTimer;
    note.addEventListener('input', function () {
      window.clearTimeout(noteTimer);
      noteTimer = window.setTimeout(function () {
        fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ note: note.value })
        });
      }, 400);
    });
  }

  var legalOpen = page.querySelector('[data-cart-legal-open]');
  var legalModal = page.querySelector('[data-cart-legal-modal]');
  if (legalOpen && legalModal) {
    function setLegalOpen(open) {
      legalModal.hidden = !open;
      document.body.style.overflow = open ? 'hidden' : '';
    }

    legalOpen.addEventListener('click', function (event) {
      event.preventDefault();
      setLegalOpen(true);
    });

    legalModal.addEventListener('click', function (event) {
      if (event.target.closest('[data-cart-legal-close]')) setLegalOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !legalModal.hidden) setLegalOpen(false);
    });
  }
})();
